export default __webpack_public_path__ + "static/media/Rectangle.60f023e3.svg";